import React, { useState, useEffect, useRef, useMemo } from 'react';

import { useIntl, history, getLocale } from 'umi';
import { Table, Bubble, Icon, Progress } from 'tea-component';
const { pageable } = Table.addons;

import {
  formatNum,
  formatPercentNum,
} from '@/pages/intelligence/utils/commonUtils';
import defaltCountryImg from '@/pages/home/assets/img/flag/default.svg';
import { PHEAT_NEW_TIP } from '@/pages/intelligence/pages/MarketProfile/_config/Const';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import xbox from '@/pages/intelligence/assets/svg/marketprofile/xbox.svg';
import playstation from '@/pages/intelligence/assets/svg/marketprofile/playstation.svg';
import nintendo from '@/pages/intelligence/assets/svg/marketprofile/nintendo.svg';

import appstore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';

import Steam from '@/pages/intelligence/assets/svg/marketprofile/Steam.svg';
import Epic from '@/pages/intelligence/assets/svg/marketprofile/Epic.svg';
import PS4 from '@/pages/intelligence/assets/svg/marketprofile/PS4.svg';
import PHeat from '@/pages/intelligence/assets/svg/marketprofile/PHeat.svg';
import hbtGooglePlay from '@/pages/intelligence/assets/svg/marketprofile/hbt-google-play.svg';

import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { dbiBtnLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedBtnPoint } from '@/pages/home/utils/buriedPoint';
import SvgIcon from '@/pages/home/components/SvgIcon';
import CloumsCenter from "@intelligence/components/TableComponents/components/CloumsCenter";

export default function NewRelease(props: any) {
  /**
   * title ： 标题栏标题
   * time ： 标题栏时间
   * data ： 展示的数据
   * gameType ： 游戏类型对应不同的展示内容，mobile、pc、console、company
   * icon ： 表格表头的revenue图标
   * needTitle ： 是否需要标题栏
   */
  const { title, data, time, gameType, loading, type, gotoGameDetailsPage } =
    props;
  const [tableColumn, setTableColumn] = useState([]);
  const { scrollable } = Table.addons;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  useEffect(() => {
    getColumns();
  }, [gameType, locale]);

  const getColumns = () => {
    let columns = [] as any;
    if (type === 'newRelease') {
      if (gameType == 'mobile') {
        columns = [
          {
            key: 'name',
            header: formatMessage({ id: 'dbi_game' }),
            width: 300,
            render: (cvm: any) => (
              <FirstRow
                cvm={{
                  imgType: gameType,
                  gametitle: cvm.name,
                  img: cvm.gameIcon,
                  countryIcon: cvm['conutryFlag'] || defaltCountryImg,
                  text: cvm['desc'],
                }}
                onClick={() => {
                  gotoGameDetailsPage(cvm, {
                    ...dbiBtnLogMes.marketProfileInsightsClickGame,
                    extInfo: 'New Release',
                  });
                }}
                rihgtClickToJumpHref={gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'New Release',
                }, false)}
              />
            ),
          },
          // {
          //   key: 'heat',
          //   header: (
          //     <SortBy
          //       title={formatMessage({ id: 'dbi_top_pheat' })}
          //       isNoDropdown={true}
          //       svgIcon={PHeat}
          //       content={PHEAT_NEW_TIP}
          //     />
          //   ),
          //   width: 200,
          //   align: 'right',
          //   render: (cvm: any) => (cvm['heat'] ? Math.floor(cvm['heat']) : '-'),
          // },
          {
            key: 'app_top_free',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_free' })}
                isNoDropdown={true}
                svgIcon={appstore}
              />
            ),
            width: 200,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['app_top_free_change'] > 0
                      ? 'up'
                      : cvm['app_top_free_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['app_top_free_change'] == 0
                      ? '-'
                      : Math.abs(cvm['app_top_free_change'])
                  }
                  value={
                    cvm['app_top_free'] != 0 ? '#' + cvm['app_top_free'] : '-'
                  }
                />
              </div>
            ),
          },
          {
            key: 'app_top_grossing',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_grossing' })}
                isNoDropdown={true}
                svgIcon={appstore}
              />
            ),
            width: 200,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['app_top_grossing_change'] > 0
                      ? 'up'
                      : cvm['app_top_grossing_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['app_top_grossing_change'] == 0
                      ? '-'
                      : Math.abs(cvm['app_top_grossing_change'])
                  }
                  value={
                    cvm['app_top_grossing'] != 0
                      ? '#' + cvm['app_top_grossing']
                      : '-'
                  }
                />
              </div>
            ),
          },
          {
            key: 'google_top_free',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_free' })}
                isNoDropdown={true}
                svgIcon={hbtGooglePlay}
              />
            ),
            width: 200,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['google_top_free_change'] > 0
                      ? 'up'
                      : cvm['google_top_free_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['google_top_free_change'] == 0
                      ? '-'
                      : Math.abs(cvm['google_top_free_change'])
                  }
                  value={
                    cvm['google_top_free'] != 0
                      ? '#' + cvm['google_top_free']
                      : '-'
                  }
                />
              </div>
            ),
          },
          {
            key: 'google_top_grossing',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_store_rank_top_grossing' })}
                isNoDropdown={true}
                svgIcon={hbtGooglePlay}
              />
            ),
            width: 200,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['google_top_grossing_change'] > 0
                      ? 'up'
                      : cvm['google_top_grossing_change'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['google_top_grossing_change'] == 0
                      ? '-'
                      : Math.abs(cvm['google_top_grossing_change'])
                  }
                  value={
                    cvm['google_top_grossing'] != 0
                      ? '#' + cvm['google_top_grossing']
                      : '-'
                  }
                />
              </div>
            ),
          },
          {
            key: 'release_time',
            align: 'center',
            width: 170,
            header: (
              <CloumsCenter width={170} align="left">
                <SortBy
                  align="left"
                  title={formatMessage({ id: 'dbi_release_date' })}
                  isNoDropdown={true}
                />
              </CloumsCenter>
            ),
            render: (cvm: any) => (
              <CloumsCenter width={170} align="left">
                {cvm.release_time || '-'}
              </CloumsCenter>
            ),
          },
        ];
      } else if (gameType == 'pc') {
        columns = [
          {
            key: 'name',
            header: formatMessage({ id: 'dbi_game' }),
            width: 400,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                cvm={{
                  imgType: gameType,
                  gametitle: cvm.name,
                  img: cvm.gameIcon,
                  countryIcon: cvm['conutryFlag'] || defaltCountryImg,
                  text: cvm['desc'],
                }}
                onClick={() => {
                  gotoGameDetailsPage(cvm, {
                    ...dbiBtnLogMes.marketProfileInsightsClickGame,
                    extInfo: 'New Release',
                  });
                }}
                rihgtClickToJumpHref={gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'New Release',
                }, false)}
              />
            ),
          },
          {
            key: 'pheat',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_top_pheat' })}
                isNoDropdown={true}
                svgIcon={PHeat}
                content={PHEAT_NEW_TIP}
              />
            ),
            width: 300,
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv">
                  {item['heat'] ? Math.floor(item['heat']) : '-'}
                </div>
              </div>
            ),
          },
          {
            key: 'pcu',
            header: (
              <SortBy
                title={`Steam ${formatMessage({ id: 'dbi_pcu' })}`}
                isNoDropdown={true}
                svgIcon={Steam}
              />
            ),
            width: 300,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['pcuChange'] > 0
                      ? 'up'
                      : cvm['pcuChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['pcuChange'] == 0
                      ? '-'
                      : formatPercentNum(cvm['pcuChange'])
                  }
                  value={cvm['pcu'] != 0 ? formatNum(cvm['pcu']) : '-'}
                />
              </div>
            ),
          },
          {
            key: 'trending',
            header: (
              <SortBy
                title={'Steam New&Trending'}
                isNoDropdown={true}
                svgIcon={Steam}
              />
            ),
            width: 300,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['trendingChange'] > 0
                      ? 'up'
                      : cvm['trendingChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['trendingChange'] == 0
                      ? '-'
                      : Math.abs(cvm['trendingChange'])
                  }
                  value={cvm['trending'] != 0 ? '#' + cvm['trending'] : '-'}
                />
              </div>
            ),
          },
          {
            key: 'relaseDate',
            header: formatMessage({ id: 'dbi_label_release_date' }),
            width: 200,
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv" style={{ width: 'auto' }}>
                  {item['relaseDate'] ? item['relaseDate'] : '-'}
                </div>
              </div>
            ),
          },
        ];
      } else if (gameType == 'console') {
        columns = [
          {
            key: 'name',
            header: formatMessage({ id: 'dbi_game' }),
            width: 400,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                cvm={{
                  imgType: gameType,
                  gametitle: cvm.name,
                  img: cvm.gameIcon,
                  countryIcon: cvm['conutryFlag'] || defaltCountryImg,
                  text: cvm['desc'],
                  icon: cvm['platList']?.map((obj: string) => {
                    if (obj.toUpperCase() == 'PS') return playstation;
                    else if (obj.toUpperCase() == 'XBOX') return xbox;
                    else if (obj.toUpperCase() == 'NINTENDO') return nintendo;
                    else {
                      return '';
                    }
                  }),
                }}
                onClick={() => {
                  gotoGameDetailsPage(cvm, {
                    ...dbiBtnLogMes.marketProfileInsightsClickGame,
                    extInfo: 'New Release',
                  });
                }}
                rihgtClickToJumpHref={gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'New Release',
                }, false)}
              />
            ),
          },
          {
            key: 'heat',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_top_pheat' })}
                isNoDropdown={true}
                svgIcon={PHeat}
                content={PHEAT_NEW_TIP}
              />
            ),
            width: 300,
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv">
                  {item['heat'] ? Math.floor(item['heat']) : '-'}
                </div>
              </div>
            ),
          },
          {
            key: 'newGame',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_company_new_games' })}
                isNoDropdown={true}
                svgIcon={PS4}
              />
            ),
            width: 300,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['newGameChange'] > 0
                      ? 'up'
                      : cvm['newGameChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['newGameChange'] == 0
                      ? '-'
                      : Math.abs(cvm['newGameChange'])
                  }
                  value={cvm['newGame'] != 0 ? '#' + cvm['newGame'] : '-'}
                />
              </div>
            ),
          },
          {
            key: 'newRelease',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_new_release' })}
                isNoDropdown={true}
                svgIcon={xbox}
              />
            ),
            width: 300,
            align: 'right',
            render: (cvm: any) => (
              <div className="dbi-insights-table-flex">
                <TableShowData
                  type={
                    cvm['newReleaseChange'] > 0
                      ? 'up'
                      : cvm['newReleaseChange'] < 0
                      ? 'down'
                      : ''
                  }
                  growth={
                    cvm['newReleaseChange'] == 0
                      ? '-'
                      : Math.abs(cvm['newReleaseChange'])
                  }
                  value={cvm['newRelease'] != 0 ? '#' + cvm['newRelease'] : '-'}
                />
              </div>
            ),
          },
          {
            key: 'releaseDate',
            header: formatMessage({ id: 'dbi_label_release_date' }),
            width: 200,
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv" style={{ width: 'auto' }}>
                  {item['relaseDate'] ? item['relaseDate'] : '-'}
                </div>
              </div>
            ),
          },
        ];
      }
    } else if (type === 'upComing') {
      if (gameType == 'mobile') {
        columns = [
          {
            key: 'name',
            header: formatMessage({ id: 'dbi_game' }),
            width: 300,
            render: (cvm: any) => (
              <FirstRow
                cvm={{
                  imgType: gameType,
                  gametitle: cvm.name,
                  img: cvm.cover,
                  countryIcon: cvm['country_img'] || defaltCountryImg,
                  text: cvm['publisher'],
                }}
                onClick={() => {
                  gotoGameDetailsPage(cvm, {
                    ...dbiBtnLogMes.marketProfileInsightsClickGame,
                    extInfo: 'Upcoming',
                  });
                }}
                rihgtClickToJumpHref={gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Upcoming',
                }, false)}
              />
            ),
          },
          {
            key: 'heat',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_top_pheat' })}
                isNoDropdown={true}
                svgIcon={PHeat}
                content={PHEAT_NEW_TIP}
              />
            ),
            width: 200,
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv">
                  {item['heat'] ? Math.floor(item['heat']) : '-'}
                </div>
              </div>
            ),
          },
          {
            key: 'relaseDate',
            header: formatMessage({ id: 'dbi_label_release_date' }),
            align: 'right',
            width: 200,
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv" style={{ width: 'auto' }}>
                  {item['release_date'] ? item['release_date'] : '-'}
                </div>
              </div>
            ),
          },
        ];
      } else if (gameType == 'pc') {
        columns = [
          {
            key: 'name',
            header: formatMessage({ id: 'dbi_game' }),
            width: 400,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                cvm={{
                  imgType: gameType,
                  gametitle: cvm.name,
                  img: cvm.cover,
                  countryIcon: cvm['country_img'] || defaltCountryImg,
                  text: cvm['publisher'],
                }}
                onClick={() => {
                  gotoGameDetailsPage(cvm, {
                    ...dbiBtnLogMes.marketProfileInsightsClickGame,
                    extInfo: 'Upcoming',
                  });
                }}
                rihgtClickToJumpHref={gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Upcoming',
                }, false)}
              />
            ),
          },
          {
            key: 'heat',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_top_pheat' })}
                isNoDropdown={true}
                svgIcon={PHeat}
                content={PHEAT_NEW_TIP}
              />
            ),
            width: '200px',
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv">
                  {item['heat'] ? Math.floor(item['heat']) : '-'}
                </div>
              </div>
            ),
          },
          {
            key: 'release_date',
            header: formatMessage({ id: 'dbi_label_release_date' }),
            align: 'right',
            width: 200,
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv" style={{ width: 'auto' }}>
                  {item['release_date'] ? item['release_date'] : '-'}
                </div>
              </div>
            ),
          },
        ];
      } else if (gameType == 'console') {
        columns = [
          {
            key: 'name',
            header: formatMessage({ id: 'dbi_game' }),
            width: 400,
            fixed: 'left',
            render: (cvm: any) => (
              <FirstRow
                cvm={{
                  imgType: gameType,
                  gametitle: cvm.name,
                  img: cvm.cover,
                  countryIcon: cvm['country_img'] || defaltCountryImg,
                  text: cvm['publisher'],
                  icon: cvm['platform'].split('|')?.map((obj: string) => {
                    if (obj.toUpperCase() == 'PS') return playstation;
                    else if (obj.toUpperCase() == 'XBOX') return xbox;
                    else if (obj.toUpperCase() == 'NINTENDO') return nintendo;
                    else {
                      return '';
                    }
                  }),
                }}
                onClick={() => {
                  gotoGameDetailsPage(cvm, {
                    ...dbiBtnLogMes.marketProfileInsightsClickGame,
                    extInfo: 'Upcoming',
                  });
                }}
                rihgtClickToJumpHref={gotoGameDetailsPage(cvm, {
                  ...dbiBtnLogMes.marketProfileInsightsClickGame,
                  extInfo: 'Upcoming',
                }, false)}
              />
            ),
          },
          {
            key: 'heat',
            header: (
              <SortBy
                title={formatMessage({ id: 'dbi_top_pheat' })}
                isNoDropdown={true}
                svgIcon={PHeat}
                content={PHEAT_NEW_TIP}
              />
            ),
            width: 200,
            align: 'right',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv">
                  {item['heat'] ? Math.floor(item['heat']) : '-'}
                </div>
              </div>
            ),
          },
          {
            key: 'release_date',
            header: formatMessage({ id: 'dbi_label_release_date' }),
            align: 'right',
            width: '200px',
            render: (item) => (
              <div className="mpGameListItem2">
                <div className="styleDiv" style={{ width: 'auto' }}>
                  {item['release_date'] ? item['release_date'] : '-'}
                </div>
              </div>
            ),
          },
        ];
      }
    }

    setTableColumn(columns);
  };

  const goToNewRelease = () => {
    buriedBtnPoint(
      dbiBtnLogMes[
        type === 'newRelease'
          ? 'marketProfileInsightsNewRelease'
          : 'marketProfileInsightsUpcoming'
      ],
    );
    const gameKind =
      gameType === 'mobile'
        ? 'mobileGames'
        : gameType === 'pc'
        ? 'pcGames'
        : 'consoleGames';
    history.push({
      pathname: `/intelligence/topCharts/${gameKind}/${
        type === 'newRelease' ? 'NewRelease' : 'Upcoming'
      }`,
    });
  };
  const getNoDataText = useMemo(()=>{
    return locale === 'zh-CN' ? `${title} 开发中。` : `We're working on the ${title} page.`
  },[locale,title])
  return (
    <CardSlot
      className="tabdetails-top"
      iconList={null}
      getDetails={goToNewRelease}
      isTitleAction={true}
      title={
        <div className="tabdetails-gamehead">
          <div className="tabdetails-gamehead-title">
            <span>{title}</span>
            <SvgIcon type="arrow-right" className="card-sort-icon" />
          </div>
          <div className="tabdetails-gamehead-text">{time}</div>
        </div>
      }
    >
      {loading ? (
        <div style={{ height: 200 }}>
          <Loading content={formatMessage({ id: 'common_loading' })} />
        </div>
      ) : data && data.length > 0 ? (
        <Table
          className="dbi-insights-table"
          records={data}
          bordered={type === 'newRelease'&&gameType == 'mobile'?'all':''}
          columns={[...tableColumn]}
          addons={[
            pageable(),
            scrollable({
              minWidth: 1000,
            }),
          ]}
        />
      ) : (
        <div style={{ height: 200 }}>
          <NoData text={getNoDataText} />
        </div>
      )}
    </CardSlot>
  );
}
